import qs from "qs";
export default {
  data() {
    return {
      iframeContent: null,
      isContentInsideIframe: false,
    };
  },
  methods: {
    checkThatAppInsideIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    isInsideIframe() {
      try {
        this.iframeContent = window.self !== window.top;
        if (window.self !== window.top) {
          document.body.style.backgroundColor = "#fff";
        }
      } catch (e) {
        return true;
      }
    },

    getQueryParameters() {
      return qs.parse(window.location.search.substring(1));
    },
  },
};
